module.exports = __webpack_public_path__ + "img/xwzx.b020dae3.jpg";